import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormUsedGameComponent from '../components/FormUsedGameComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { getProductImageFolder } from '../utils/productForm';
import { clearProductImages, uploadProductImages } from '../utils/productImages';
import { stateLabel } from '../utils/usedGame';

var config = process.env;

const USED_PRODUCT_TYPE = 3;

class EditUsedGamePage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, disabled: false, initial: null, code: null };
    }

    async componentDidMount() {
        const role = await validateSession();
        const params = new URLSearchParams(this.props.location.search);
        const code = params.get('code');
        this.setState({ checked: true, role, code });
        this.fetchData(code);
    }

    fetchData = (code) => {
        const request = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `used-games/${code}`, request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error === 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    this.setState({ initial: data.data });
                }
            });
    }

    handleChangeData = (value) => {
        this.setState({ disabled: true });
        const { images, imagesReady, ...payload } = value;
        const request = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
            body: JSON.stringify(payload),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `used-games/${this.state.code}`, request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    this.setState({ disabled: false });
                    return;
                }
                // Se vacía la carpeta y se reescribe entera. El picker cargó al abrir las que ya
                // estaban y las reenvía, así que borrar es seguro: lo que se borra vuelve. Es
                // además la única forma de que borrar una imagen en la grilla tenga efecto real.
                //
                // ⚠️ "El picker YA cargó" no se cumple solo: la carga es asíncrona. Si todavía hay
                // imágenes en vuelo se guardan los datos y NO se tocan las imágenes — borrarlas
                // ahora sería perderlas (pasó en productos el 2026-08-17).
                if (imagesReady !== true) {
                    alert(
                        'Los datos se guardaron.\n\n'
                        + 'Las imágenes NO se tocaron porque todavía se estaban cargando las que el '
                        + 'juego ya tenía. Volvé a entrar, esperá a que aparezcan en la grilla y '
                        + 'guardá de nuevo si querés cambiarlas.',
                    );
                    navigateTo('/usedGames');
                    return;
                }
                const folder = getProductImageFolder(USED_PRODUCT_TYPE, this.state.code);
                clearProductImages(folder)
                    .then(() => uploadProductImages(folder, images, (pct) => this.setState({ uploadValue: pct })))
                    .then(() => navigateTo('/usedGames'))
                    .catch(() => {
                        alert('Los datos se guardaron, pero falló la subida de alguna imagen.');
                        navigateTo('/usedGames');
                    });
            });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={22} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Usados" subtitle="Editar juego usado" />
                            {this.state.initial != null && this.state.initial.state !== 'available' ? (
                                // Vendido o retirado es final: la URL escrita a mano (o la redirección
                                // desde la edición de productos) no abre el form. El backend lo rechaza igual.
                                <div className="card card-small mb-4">
                                    <div className="card-body p-4">
                                        <p className="mb-2">
                                            <strong>{this.state.initial.name}</strong> está{' '}
                                            <strong>{stateLabel(this.state.initial.state).toLowerCase()}</strong>: ya no se puede editar.
                                        </p>
                                        {this.state.initial.state === 'sold' && this.state.initial.soldPurchaseId != null && (
                                            <button type="button" className="btn btn-white mr-2" onClick={() => navigateTo(`/purchase?id=${this.state.initial.soldPurchaseId}`)}>
                                                Ver venta
                                            </button>
                                        )}
                                        <button type="button" className="btn btn-white" onClick={() => navigateTo('/usedGames')}>
                                            Volver a Usados
                                        </button>
                                    </div>
                                </div>
                            ) : this.state.initial != null ? (
                                <FormUsedGameComponent
                                    editMode
                                    initial={this.state.initial}
                                    onChangeData={this.handleChangeData}
                                    disabled={this.state.disabled}
                                    role={this.state.role}
                                    imagesFolder={getProductImageFolder(USED_PRODUCT_TYPE, this.state.code)}
                                />
                            ) : (
                                <div className="card card-small mb-4"><div className="card-body p-4">Cargando…</div></div>
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default EditUsedGamePage;
